import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { getMeeting } from 'modules/zoom/actions';
import ZoomMeeting from '../components';

function mapStateToProps(state) {
  return {
    meeting: state.zoom.meeting,
    meetingStatus: state.zoom.meetingStatus,
    color: state.app.color1,
    literals: state.i18n.literals.zoomMeeting,
    app: state.app,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getMeeting: bindActionCreators(getMeeting, dispatch),
  };
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ZoomMeeting),
);



// WEBPACK FOOTER //
// ./src/routes/ZoomMeeting/container/index.js